import { productList } from '../../common';
import { downloadExcel } from '../../../utils/excel';

/** Exports the price rows exactly as before (same columns, fallbacks and file name). */
export function downloadPrices(prices) {
    const columns = ['Producto', 'Codigo', 'Precio en Piso', 'Margen en Piso', 'Precio Sugerido', 'Margen Sugerido', 'Promoción'];
    const data = prices?.map((prod) => ({
        Producto: prod?.name,
        Codigo: prod?.code || productList?.filter((p) => p?.name === prod?.name)[0]?.value || '',
        'Precio en Piso': isNaN(prod?.storePrice) ? 0 : prod?.storePrice,
        'Margen en Piso': isNaN(prod?.margin) ? '0.0%' : prod?.margin,
        'Precio Sugerido': isNaN(prod?.suggestedPrice) ? 0 : prod?.suggestedPrice,
        'Margen Sugerido': isNaN(prod?.suggestedMargin) ? '0.0%' : prod?.suggestedMargin,
        Promoción: prod?.isPromo
    }));
    downloadExcel(columns, data, 'Precios');
}

/** Tone for a signed percentage string ("12.30%"): positive / negative / zero. */
export function signedTone(text, positive, negative) {
    const value = parseFloat(text);
    if (value > 0) return positive;
    if (value < 0) return negative;
    return 'neutral';
}
